import { FunctionComponent } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';

import {
  COMPLETE_INPUT_PROPS,
  COMPLETE_INPUT_VALIDATION,
  EASINESS_PROPS,
  PRESSURE_PROPS,
} from './constants';

const SatNoteFormQuestions: FunctionComponent = () => (
  <>
    <div className="font-bold text-14-22-em text-neutral-700 mb-6">
      Please answer the below questions
    </div>
    <Field.Validator validation={COMPLETE_INPUT_VALIDATION}>
      <Field.Select {...COMPLETE_INPUT_PROPS} />
    </Field.Validator>
    <Widget.JobSatNoteQPressure {...PRESSURE_PROPS} />
    <Widget.JobSatNoteQEasiness {...EASINESS_PROPS} />
    <Field.FingerprintBooleanInput
      handle="checkbox"
      name="acknowledged"
      fieldText="I acknowledge that by clicking the submit button I agree the job has been completed satisfactorily"
    />
  </>
);

export default SatNoteFormQuestions;
